///<reference path='../../../mobile/core/directives/AutocompleterField.ts'/>
'use strict';
/*
    Creates an airport multi select field.
    Selectable options are exposed as `ac.data`.
*/
namespace Autocompleter {

    class AirportMultiSelectUnified2 extends AutocompleterField {

        private available: any[] = [];
        private selectAttrFn: (item: any) => void;
        private isCodeSelected: (code: string) => boolean =
            (code: string) => _.find(this.currentValue, v => code === v.Code);

        prefilled: string;
        notActive: boolean;
        _placeholder: string;
        elements: any;
        iconName: string;

        constructor (
            public $scope: any,
            public $route: ng.route.IRouteService,
            public autocompleter: any,
            public resourceService: Core.ResourceService,
            public $q: ng.IQService,
            private destinationService: any,
            public $timeout: ng.ITimeoutService
        ) {
            super();
            if (!this.areaOverride) {
            	this.areaOverride = 'flights';
            }
            this.$scope.$watch('ac.currentValue', v => {
                if (v) {
                    this._refreshData();
                }
            });

            // Wrap `select` attribute fn
            this.selectAttrFn = this.select;
            this.select = (item) => {
                this.selectItem(item);
                this.selectAttrFn({items: this.currentValue});
            };

            if(this.prefilled != null) {
                this.prefill(this.prefilled);
            } else if (this.getArea() === 'flights-departure') {
                this.autocompleter.initialDepartureAirports().then(result => this.update(result));
            }

            this.$scope.$watch('extraFocusTrackerFocused', (val, old) => {
                if (val === false && old === true) {
                    this.blur();
                }
            });
        }

        init (elements): void {
            this.elements = elements;
            this.inputField = this.elements.input;
        }

        private prefill(data) {
            let prefill = data.split(/\s*,\s*/);
            this.prefix = data;
            this.fetch().then(() => {
                prefill.forEach(code => {
                    this.available.forEach(item => {
                        if(item.Code === code) {
                            this.select(item);
                        }
                    });
                });
            });
        }

        set placeholder(placeholder) {
            if(!this.notActive) {
                this._placeholder = placeholder;
            } else {
                this._placeholder = this.resourceService.get('DEFAULTAIRPORT');
            }
        }

        get placeholder() {
            return this._placeholder;
        }

        update (result: any): void {
            // Called by super.fetch() with autocompleter.lookup result
            this.available = result.data;
            this._refreshData();

            if (this.data && !this.data.length && !this.notActive) {
                this.data = null;

                const prefix = (result.prefix + '').toLowerCase();
                const hasPrefixAlreadyBeenUsed: boolean = prefix &&
                    _.find(this.currentValue, v => (v.Title + '').toLowerCase().indexOf(prefix) > -1);

                if(!hasPrefixAlreadyBeenUsed) {
                    this.$scope.$emit('flash:error', this.resourceService.get('NOMATCHES'));
                }
            }
        }

        selectItem (item: any): void {
            if (item && item.Code) {
                // Add codes which are not already selected
                let codes = item.Code.split(',');
                _.forEach(codes, (code: string) => {
                    if(!this.isCodeSelected(code)) {
                        if(!this.currentValue) {
                            this.currentValue = [];
                        }
                        let individual = _.find(this.available, i => i.Code === code);
                        individual = individual ? angular.copy(individual) : {Code: code, Title: item.Title};
                        this.currentValue.push(individual);
                    }
                });
                this.prefix = '';
                this._refreshData();
            }
        }

        removeItem (item: any): void {
            if (!item) { return; }
            this.currentValue.splice(this.currentValue.indexOf(item), 1);

            if (!this.currentValue.length) {
                this.deselect();
            } else {
                this.selectAttrFn({items: this.currentValue});
            }
            this._refreshData();
        }

        blur () {
            this.$timeout(() => {
                if (this.prefix) {
                    var firstItem = _.find(this.data || [], d => !d.header);
                    if (firstItem) {
                        this.select(firstItem);
                    }
                }
            }, 200);
        }

        focusOnInput() {
            this.inputField.focus();
        }

        firstTitle() {
            if (!this.$scope.extraFocusTrackerFocused) {
                if (this.currentValue && this.currentValue[0]) {
                    return this.getTitle(this.currentValue[0]);
                }
            }
        }
        titleCache = {};
        getTitle(airport) {
            if (airport.Code in this.titleCache) {
                return this.titleCache[airport.Code];
            }
            if (airport.Title) {
                return this.titleCache[airport.Code] = this.formatTitle(airport.Title);
            }
            this.destinationService
                .getAirport(airport.Code)
                .then(airport => this.titleCache[airport.Code] = this.formatTitle(airport.Title));
            return this.titleCache[airport.Code] = ' ';
        }
        formatTitle(title) {
            return (title || '').split('(')[0].split(',')[0];
        }

        private _refreshData (): void {
            //this.data = this.addHeader(this._getAvailable(), 'AIRPORTS');
            this.data = this._getAvailable();
        }

        private _getAvailable () : any[]  {
            // Filters out items where all codes are already selected
            return _.reject(
                this.available,
                item => _.every(
                    item.Code.split(','),
                    this.isCodeSelected
                )
            );
        }
    }

    angular
        .module('TR')
        .directive('airportMultiSelectUnified2', (): ng.IDirective => {
            return {
                restrict: 'E',
                replace: true,
                scope: {},
                controllerAs: 'ac',
                bindToController: {
                    placeholder: '@',
                    select: '&',
                    deselect: '&',
                    currentValue: '=',
                    focusTracker: '=',
                    minPrefix: '@',
                    notActive: '@',
                    prefilled: '@',
                    disabled: '@',
                    areaOverride: '@',
                    iconName: '@?'
                },
                templateUrl: 'partials/home/directivetemplate?type=AirportMultiSelectUnified',
                controller: AirportMultiSelectUnified2,
                transclude: true,
                link: (
                    scope: any,
                    el: JQuery,
                    attrs,
                    ac: AirportMultiSelectUnified2
                ) => {
                    const elements = {
                        el: el,
                        field: el.find('.field'),
                        input: el.find('input')
                    };
                    ac.init(elements);
                }
            };
        });
}
